import { useEffect, useRef, useState } from "react";

const PHOTOS = [
  "/realisations/realisation-1.jpg",
  "/realisations/realisation-2.jpg",
  "/realisations/realisation-3.jpg",
  "/realisations/realisation-4.jpg",
  "/realisations/realisation-5.jpg",
  "/realisations/realisation-6.jpg",
  "/realisations/realisation-7.jpg",
  "/realisations/realisation-8.jpg",
];

const AUTOPLAY_MS = 5000;

export default function RealisationsCarousel() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (paused) return;
    timerRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % PHOTOS.length);
    }, AUTOPLAY_MS);
    return () => clearInterval(timerRef.current);
  }, [paused]);

  const goTo = (i) => {
    setIndex(((i % PHOTOS.length) + PHOTOS.length) % PHOTOS.length);
  };

  return (
    <section
      className="py-16 sm:py-20 bg-white"
      data-testid="realisations-carousel-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-xs uppercase tracking-[0.28em] font-semibold text-[#005BBB] mb-3">
            Chantier récent
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#001B35]">
            Rénovation complète d'une <span className="text-[#005BBB]">douche</span>
          </h2>
          <div className="mt-5 w-16 h-1 bg-[#005BBB] mx-auto rounded-full" />
        </div>

        <div
          className="relative rounded-3xl overflow-hidden shadow-[0_20px_60px_-24px_rgba(0,27,53,0.4)] bg-[#001B35]"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          onTouchStart={() => setPaused(true)}
          onTouchEnd={() => setPaused(false)}
          data-testid="realisations-carousel"
        >
          {/* Slides */}
          <div className="relative w-full aspect-[4/3] sm:aspect-[16/10] lg:aspect-[16/9]">
            {PHOTOS.map((src, i) => (
              <img
                key={src}
                src={src}
                alt={`Chantier étape ${i + 1} sur ${PHOTOS.length}`}
                loading={i === 0 ? "eager" : "lazy"}
                className={`absolute inset-0 w-full h-full object-contain bg-[#001B35] transition-opacity duration-1000 ease-in-out ${
                  i === index ? "opacity-100" : "opacity-0 pointer-events-none"
                }`}
                data-testid={`carousel-slide-${i + 1}`}
              />
            ))}
          </div>

          {/* Counter badge */}
          <div className="absolute top-4 right-4 rounded-full bg-black/50 backdrop-blur-sm text-white text-xs font-semibold px-3 py-1.5 tracking-wider">
            {String(index + 1).padStart(2, "0")} / {String(PHOTOS.length).padStart(2, "0")}
          </div>

          {/* Progress bar */}
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/10">
            <div
              key={`${index}-${paused}`}
              className="h-full bg-[#005BBB]"
              style={{
                width: "100%",
                animation: paused
                  ? "none"
                  : `carouselProgress ${AUTOPLAY_MS}ms linear forwards`,
                transformOrigin: "left",
              }}
            />
          </div>
        </div>

        {/* Dots */}
        <div className="mt-6 flex items-center justify-center gap-2" data-testid="carousel-dots">
          {PHOTOS.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              aria-label={`Aller à la photo ${i + 1}`}
              data-testid={`carousel-dot-${i + 1}`}
              className={`h-2 rounded-full transition-all duration-300 ${
                i === index ? "w-8 bg-[#005BBB]" : "w-2 bg-gray-300 hover:bg-gray-400"
              }`}
            />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes carouselProgress {
          from { width: 0%; }
          to   { width: 100%; }
        }
      `}</style>
    </section>
  );
}
